const ENVIRONMENT = {
    DEVELOPMENT: 'http://localhost:8000',
    TEST: 'https://test-api.joinclockout.com',
    STAGING: 'https://staging.joinclockout.com',
    TVFCU_TEST: 'https://tvfcu-test.joinclockout.com',
    TVFCU_PROD: 'https://tvfcu.joinclockout.com',
};

class UrlFactory {
    apiUrl = null;

    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || ENVIRONMENT['DEVELOPMENT'];
    }

    createRegisterUrl() {
        return `${this.apiUrl}/api/user/register`;
    }

    createUserUrl() {
        return `${this.apiUrl}/api/user`;
    }

    createAuthenticateUrl() {
        return `${this.apiUrl}/api/user/authenticate`;
    }

    createReportUrl(aba, start, end, grouping) {
        if (start && end) return `${this.apiUrl}/api/report/${aba}?start=${start}&end=${end}&grouping=${grouping}`;
        return `${this.apiUrl}/api/report/${aba}`;
    }

    createFIUrl(aba) {
        return `${this.apiUrl}/api/consumer/fi/${aba}`;
    }

    createUsersUrl(aba) {
        return `${this.apiUrl}/api/users/fi/${aba}`;
    }

    createAdminUsersUrl(aba) {
        return `${this.apiUrl}/api/admin/users/${aba}`;
    }

    createLedgerUrl(aba) {
        return `${this.apiUrl}/api/consumer/ledger/${aba}`;
    }

    createYTDReportUrl(aba) {
        return `${this.apiUrl}/api/report/ytd/${aba}`;
    }

    createConsumerUserUrl(clientId) {
        return `${this.apiUrl}/api/consumer/user/${clientId}`;
    }

    createReconciliationUrl(aba) {
        return `${this.apiUrl}/api/report/unsettled-advances?aba=${aba}`;
    }

    createTreasurySummaryUrl(aba) {
        return `${this.apiUrl}/api/treasury/summary/${aba}`;
    }

    createTreasuryFundingUrl(aba) {
        return `${this.apiUrl}/api/treasury/funding/${aba}`;
    }

    createTreasuryKPIsUrl(aba) {
        return `${this.apiUrl}/api/treasury/kpis/${aba}`;
    }

    createTreasuryReceivablesUrl(aba) {
        return `${this.apiUrl}/api/treasury/receivables/${aba}`;
    }

    createTreasuryActivitiesUrl(aba) {
        return `${this.apiUrl}/api/treasury/activities/${aba}`;
    }

    createTreasuryCashflowUrl(aba) {
        return `${this.apiUrl}/api/treasury/cashflow/${aba}`;
    }

    createRemoveUserAccessUrl(aba, userId) {
        return `${this.apiUrl}/api/admin/users/${aba}/${userId}/remove-access`;
    }

    createSendInvitationUrl() {
        return `${this.apiUrl}/api/admin/users/send-invitation`;
    }

    createValidateInvitationUrl(token) {
        return `${this.apiUrl}/api/user/validate-invitation?token=${token}`;
    }

    createUpdatePasswordUrl() {
        return `${this.apiUrl}/api/user/update-password`;
    }

    createValidatePasswordResetUrl(token) {
        return `${this.apiUrl}/api/user/validate-password-reset?token=${token}`;
    }

    createUpdateAccountUrl() {
        return `${this.apiUrl}/api/user/account`;
    }

    createSendPasswordResetUrl(aba) {
        return `${this.apiUrl}/api/admin/users/send-password-reset/${aba}`;
    }

    createBillingKPIsUrl(aba) {
        return `${this.apiUrl}/api/billing/kpis/${aba}`;
    }

    createBillingStatementsUrl(aba) {
        return `${this.apiUrl}/api/billing/statements/${aba}`;
    }

    createExportBillingStatementsUrl(aba) {
        return `${this.apiUrl}/api/billing/export/${aba}`;
    }

    createSyncMonitorUrl(aba, status = null, limit = 50) {
        let url = `${this.apiUrl}/api/admin/sync-monitor/${aba}?limit=${limit}`;
        if (status) url += `&status=${status}`;
        return url;
    }

    createSyncNotifyUrl(aba) {
        return `${this.apiUrl}/api/admin/sync-monitor/${aba}/notify`;
    }

    createTroubleTicketResolveUrl(ticketId) {
        return `${this.apiUrl}/api/admin/trouble-ticket/${ticketId}/resolve`;
    }

    createPlatformsUrl(aba, provider = null, search = null) {
        let url = `${this.apiUrl}/api/admin/platforms/${aba}`;
        const params = [];
        if (provider) params.push(`provider=${provider}`);
        if (search) params.push(`search=${encodeURIComponent(search)}`);
        if (params.length > 0) url += `?${params.join('&')}`;
        return url;
    }

    createPlatformOutagesUrl(aba, platformId = null, provider = null, status = 'active') {
        let url = `${this.apiUrl}/api/admin/platform-outages/${aba}`;
        const params = [];
        if (platformId) params.push(`platform_id=${platformId}`);
        if (provider) params.push(`provider=${provider}`);
        if (status) params.push(`status=${status}`);
        if (params.length > 0) url += `?${params.join('&')}`;
        return url;
    }

    createPlatformOutageCreateUrl(aba) {
        return `${this.apiUrl}/api/admin/platform-outage/${aba}`;
    }

    createPlatformOutageUpdateUrl(aba, outageId) {
        return `${this.apiUrl}/api/admin/platform-outage/${aba}/${outageId}`;
    }

    createPlatformOutageResolveUrl(aba, outageId) {
        return `${this.apiUrl}/api/admin/platform-outage/${aba}/${outageId}/resolve`;
    }
}

export default UrlFactory;
